import React, { useEffect, useRef } from "react"
import { Button } from "antd";
import { YhBox } from "@src/components/YhBox";
import { YhForm } from "@src/components/YhFormBox";
import { FormItemTypeEnum, IFormItem, IYhFormRef } from "@src/components/YhFormBox/Types";
import { useMenuModel } from "../menuModel";
import { globalPrompt } from "@src/components/YhMessage";
import { menuService } from "../MenuService";
import moment from "moment";
import { useLockFn } from "ahooks";



const FormDict = () => {
  const {
    menuOptMode,
    appCode,
    formValues,
    selectedMenu,
    loadMenuTreeByApp,
    setSelectedMenuKeys,
    setFormValues,
    setSelectedMenu
  } = useMenuModel()

  const formRef = useRef<IYhFormRef>()
  const createCode = (): string => {
    let code = ''
    if (selectedMenu?.code) {
      code = selectedMenu?.code + '-' + (selectedMenu?.children?.length as number > 9 ? selectedMenu?.children?.length as number + 1 : '0' + (selectedMenu?.children?.length as number + 1))
    }
    return code
  }

  useEffect(() => {
    formRef.current?.resetFields()
  }, [menuOptMode, formValues])

  const initialValues = menuOptMode === 'detail' ? {
    ...formValues,
    createTime: moment(formValues.createTime).format("YYYY-MM-DD HH:mm:ss"),
    closeable: formValues.closeable === 0 ? true : false,
    isShow: formValues.isShow === 0 ? true : false,
    status: formValues.status === 0 ? true : false,
  } : {
      pcode: selectedMenu?.code,
      code: createCode(),
      createTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      status: true,
      isShow: true,
      closeable: true,
    }

  const items: IFormItem[] = [
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "父级菜单",
      fieldName: "pcode",
      disable: true,
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "菜单编号",
      disable: menuOptMode === "detail",
      fieldName: "code",
      rules: [{ required: true, message: '该项为必填项' }],
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "菜单名称",
      fieldName: "name",
      rules: [{ required: true, message: '该项为必填项' }],
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "菜单地址",
      fieldName: "linkUrl",
      // disable: true,
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "菜单图标",
      fieldName: "iconfont",
      // disable: true,
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "创建时间",
      disable: true,
      fieldName: "createTime",
      // rules: [{ required: true, message: '该项为必填项' }],
      span: 15,
    }, {
      type: FormItemTypeEnum.Input,
      fieldLabel: "职能描述",
      fieldName: "note",
      span: 15,
      // rules: [{ required: true, message: '该项为必填项' }]
    }, {
      type: FormItemTypeEnum.Switch,
      fieldLabel: "展示菜单",
      fieldName: "isShow",
      offset: 1,
      span: 11,
    }, {
      type: FormItemTypeEnum.Switch,
      fieldLabel: "菜单可关闭",
      fieldName: "closeable",
      pull: 4,
      span: 11,
    }, {
      type: FormItemTypeEnum.Switch,
      fieldLabel: "菜单状态",
      fieldName: "status",
      span: 15,
    }
  ]


  const onSubmit = useLockFn(async () => {
    try {
      const formData = await formRef.current?.validateFields();
      if (formData) {
        const params = {
          ...formData,
          appCode,
          closeable: formData.closeable ? 0 : 1,
          isShow: formData.isShow ? 0 : 1,
          status: formData.status ? 0 : 1,
        }
        if (menuOptMode !== "detail") {
          const insertRet = await menuService.insert(params);
          if (insertRet.success) {
            await globalPrompt("message", { type: "success", text: '新增成功!' });
            await loadMenuTreeByApp();
            onCancel()
          } else {
            await globalPrompt("message", { type: "error", text: "新增失败!" + insertRet.retMsg });
          }
        } else {
          const updateRet = await menuService.update(params);
          if (updateRet.success) {
            await globalPrompt("message", { type: "success", text: '修改成功!' });
            await loadMenuTreeByApp();
            onCancel()
          } else {
            await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
          }
        }
      }
    } catch (e) {
      console.log("失败!");
    }
  });
  const onCancel = () => {
    formRef.current?.resetFields()
    setFormValues({})
    setSelectedMenu(undefined)
    setSelectedMenuKeys([])
  }

  const onReset = () => {
    formRef.current?.resetFields()
  }
  return (
    <YhBox
      style={{ height: 'calc(100% - 80px)' }}
    >
      <YhForm
        labelCol={{ span: 6 }}
        disabled={false}
        initialValues={initialValues}
        items={items}
        formRef={formRef}
        justify="start"
      />
      <div style={{ marginLeft: "150px" }} hidden={false}>
        <Button
          onClick={onSubmit}
          shape="round"
          type="link"
        >
          {
            menuOptMode !== "detail"
              ? "添加"
              : "修改"
          }
        </Button>
        <Button
          onClick={onReset}
          shape="round"
          type="link"
        >
          重置
        </Button>
        <Button
          onClick={onCancel}
          shape="round"
        >
          取消
        </Button>
      </div>
    </YhBox>
  )
}
export default FormDict
